import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';

import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { Box } from '@mui/system';
import { SchoolContentModuleNodeLock } from '@protos/school_management/school.db_pb';
import { ReactNode, useState } from 'react';
import { ListItemButton } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
interface IProps {
  open?: boolean;
  variant: 'small' | 'medium' | 'large';
  chapterData?: any[];
  HeaderContent: ReactNode;
  handleExpandmore?: () => void;
  handleExpandless?: () => void;
  expandDisabled: boolean;
  ListItemArray: React.ReactNode[];
  listRightPadding?: string;
}
export function ContentListAccordian(props: IProps) {
  const [expanded, setExpanded] = useState(false);
  const {
    open,
    variant,
    chapterData,
    ListItemArray,
    HeaderContent,
    handleExpandmore,
    handleExpandless,
    expandDisabled,
    listRightPadding,
  } = props;
  const expandState = open ? open : expanded;
  return (
    <List
      sx={{
        padding: '0px',
        borderRadius: '10px',
        border: '2px solid #A8D3FC',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#F5FAFF',
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <Box
        sx={{
          boxSizing: 'border-box',
          alignItems: 'center',
          padding: '0px 10px',
          display: 'flex',
          width: '100%',
          height: 'auto', //variantMapping[variant]?.height,
          minHeight: variantMapping[variant]?.height,
          justifyContent: 'space-between',
          borderBottom: expandState ? '2px solid #A8D3FC' : 'none',
        }}
      >
        <AccordianHeaderComponent
          children={HeaderContent}
          expanded={expandState}
          handleExpandless={
            handleExpandless
              ? handleExpandless
              : (ev?: React.MouseEvent) => {
                  ev?.stopPropagation();
                  setExpanded(false);
                }
          }
          handleExpandmore={
            handleExpandmore
              ? handleExpandmore
              : (ev?: React.MouseEvent) => {
                  ev?.stopPropagation();
                  setExpanded(true);
                }
          }
          disabled={expandDisabled}
        ></AccordianHeaderComponent>
      </Box>

      <Collapse
        in={expandState}
        timeout="auto"
        unmountOnExit
        sx={{ width: '100%' }}
      >
        <List component="div" disablePadding>
          {ListItemArray.map((item, i) => {
            return (
              <Box
                key={i}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  width: '100%',
                  height: {
                    xs: `calc(${variantMapping[variant]?.height.xs}-${pxToRem(
                      10
                    )})`,
                    md: `calc(${variantMapping[variant]?.height.md}-${pxTovW(
                      5
                    )})`,
                  },
                  padding: '0px 10px',
                  boxSizing: 'border-box',
                  alignItems: 'center',
                  borderBottom:
                    i === ListItemArray.length - 1
                      ? 'none'
                      : '2px solid #A8D3FC',
                  backgroundColor: '#EBF5FF',
                  borderBottomLeftRadius:
                    i === ListItemArray.length - 1 ? '10px' : '0px',
                  borderBottomRightRadius:
                    i === ListItemArray.length - 1 ? '10px' : '0px',
                  paddingRight: listRightPadding || '63px',
                }}
              >
                {item}
              </Box>
            );
          })}
        </List>
      </Collapse>
    </List>
  );
}

interface AccordianHeaderprops {
  children: ReactNode;
  expanded?: boolean;
  handleExpandmore?: () => void;
  handleExpandless?: () => void;
  disabled?: boolean;
}

export const AccordianHeaderComponent = (props: AccordianHeaderprops) => {
  const { children, expanded, handleExpandmore, handleExpandless, disabled } =
    props;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
        // backgroundColor: 'red',
      }}
    >
      <Box sx={{ flexGrow: 1, minWidth: 0, width: '100%' }}>{children}</Box>
      <ListItemButton
        sx={{ px: '5px', flexShrink: 0 }}
        // onClick={() => handleExpand(chapterData)}
        disabled={disabled}
      >
        {expanded ? (
          <ExpandLess onClick={handleExpandless} />
        ) : (
          <ExpandMore onClick={handleExpandmore} />
        )}
      </ListItemButton>
    </Box>
  );
};

const variantMapping = {
  small: {
    height: { xs: pxToRem(25), md: pxTovW(30) },
  },
  medium: {
    height: { xs: pxToRem(35), md: pxTovW(55) },
  },

  large: {
    height: { xs: pxToRem(54), md: pxTovW(90) },
  },
};
